/* eslint-disable */
import React, { useState} from 'react';
import venueLabels from "../../venuemanagement/labels/venue_en.json";
import TimeTableCsvImport from './TimeTableCsvImport';
import { shallowEqual, useSelector, useDispatch} from 'react-redux';
import TimeTableLabels from '../labels/timetable_en.json';
// import ManageTimeTable from '../components/ManageTimeTable';
import AddTimeTableDetails from './AddTimeTableDetails';
import { getActiveExamList, getTimeTableDetailsByTemplateId, getExamCenterListAPI} from '../../timetablemanagement/actions/timetableManagementAction';
// import commonLabels from '../../common/labels/common_en.json';

const TimeTableCsvData = (props) => {
    const dispatch = useDispatch();
    const [showImportList, setImportumentList] = useState(false);
    const [showManageTimeTableState, setShowManageTimeTableState] = useState(false);
    const [showAddTimeTableState, setShowAddTimeTableState] = useState(false);

    const { getUploadTimeTableCsvList } = useSelector(
        (state) => state.timeTableManagementReducer,
        shallowEqual
    );

    const btnDisableState = getUploadTimeTableCsvList && getUploadTimeTableCsvList.timeTableDtoList && getUploadTimeTableCsvList.timeTableDtoList.length;
    
    const handledUploadList = () => {
        setImportumentList(true);
        dispatch(getExamCenterListAPI(props.advtId));
    };

    const handleManageTimeTable = () => {
        setShowManageTimeTableState(true);
        dispatch(getActiveExamList(props.advtId));
    };

    const handleAddTimeTableDetails = (advtId) => {
        dispatch(getTimeTableDetailsByTemplateId(props.advtId))
        setShowAddTimeTableState(true);
    };

    return (
        <div className="d-flex justify-content-center">
            <main role="main" className="col-sm-9 col-md-11 col-lg-12 " id="main_block">
                <div>
                    <div className='float-right'>
                        {/* {!((!btnDisableState) || (btnDisableState === 0)) && */}
                            <button type='button' className='btn btn-sm btn-primary me-2' onClick={handleAddTimeTableDetails}> {TimeTableLabels.ADD_TIME_TABLE} </button>
                        {/* } */}
                        {/* {!((!btnDisableState) || (btnDisableState === 0)) &&
                            <button type='button' className='btn btn-sm btn-primary mr-2' onClick={handleManageTimeTable}> {TimeTableLabels.MANAGE_TIME_TABLE} </button>
                        } */}
                        <button type='button' className='btn btn-sm btn-primary' onClick={handledUploadList}>{props.upload_button_label ? props.upload_button_label : venueLabels.UPLOAD_LIST}</button>
                    </div>

                </div>
            </main>

            <TimeTableCsvImport
                showImportList={showImportList}
                setImportumentList={setImportumentList}
                advtId={props.advtId}
                stageId={props.stageId}
            />
            {/* {showManageTimeTableState &&
            <ManageTimeTable
                showManageTimeTableState={showManageTimeTableState}
                setShowManageTimeTableState={setShowManageTimeTableState}
                advtId={props.advtId}
            />
            }  */}
            {showAddTimeTableState &&
            <AddTimeTableDetails
                setShowAddTimeTableState={setShowAddTimeTableState}
                showAddTimeTableState={showAddTimeTableState}
                advtId={props.advtId}
            />
            }
        </div>

    )
}
export default TimeTableCsvData;